// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Tn7U","requiredAsterisk":"Info_requiredAsterisk__lge9K"};